<template>
  <body>
    <TempPC v-if="$UA() === 0"/>
    <TempH5 v-else />
  </body>
</template>

<script>
import TempH5 from "../interface/TempH5/ViewCore"
import TempPC from "../interface/TempPC/ViewCore"
// import '../portal/basic.scss'
export default {
  components: {
    TempH5,
    TempPC
  }
}
</script>